var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBussinessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45.5,
    r: 45.5,
    fill: "url(#paint0_linear_1807_1713)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4466 34.4444C42.4466 33.9538 42.8448 33.5556 43.3355 33.5556H48.6688C49.1595 33.5556 49.5577 33.9538 49.5577 34.4444V37.1111H42.4466V34.4444ZM37.1133 62H54.8911V37.1111H53.1133V34.4444C53.1133 31.9947 51.1186 30 48.6688 30H43.3355C40.8857 30 38.8911 31.9947 38.8911 34.4444V37.1111H37.1133V62ZM58.4449 37.1111V62C61.3853 62 63.7782 59.6071 63.7782 56.6667V42.4444C63.7782 39.504 61.3853 37.1111 58.4449 37.1111ZM28.2227 42.4444C28.2227 39.504 30.6155 37.1111 33.556 37.1111V62C30.6155 62 28.2227 59.6071 28.2227 56.6667V42.4444Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1807_1713",
    x1: 27.268,
    y1: -2.88167,
    x2: 55.3656,
    y2: 100.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2062F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7337FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBussinessIcon);
export default __webpack_public_path__ + "static/media/bussiness-icon.b887d2f25249cca4dcf2e5c259868bf7.svg";
export { ForwardRef as ReactComponent };